<div class="checkbox-group-wrapper" [attr.data-id]="dataId">
    <label class="group-label">
        {{ label }}
        @if (required) {
<span class="text-danger">*</span>
}
    </label>

    <div class="options-container">
        @for (option of options; track option) {
<div class="checkbox-option" [attr.data-id]="option" [class.disabled]="disabled"
            (click)="!disabled && toggleSelection(option)">

            <div class="checkbox-box" [class.checked]="isChecked(option)">
                @if (isChecked(option)) {
<span class="checkmark">✔</span>
}
            </div>
            <span class="option-label">{{ option }}</span>
        </div>
}
    </div>

    @if (control.invalid && (control.dirty || control.touched)) {
<div class="text-danger">
        @if (control.errors?.required) {
<div>At least one option must be selected.</div>
}
    </div>
}
</div>